import { Tab, TabList, TabPanel, TabPanels, Tabs, useTheme } from '@chakra-ui/react';
import React, { useEffect } from 'react';
import { Event, Offer } from '../../types/article';
import EventAbout from './About';
import RelatedEvents from './RelatedEvents';
import { useSearchParams } from 'react-router-dom';
import { useRelatedEvents } from '../../hooks/useEvents';

const EventTabs = ({
  event,
  eventOffers,
  refetchEvent,
}: {
  event: Event;
  eventOffers?: Offer[];
  refetchEvent: () => void;
}) => {
  const theme = useTheme();

  const tabs = ['About'];

  const { data: relatedEventsResponse } = useRelatedEvents(event.id);
  const relatedEvents = relatedEventsResponse?.data.data || [];

  if (relatedEvents.length > 0) {
    tabs.push('Related Events');
  }

  const [searchParams] = useSearchParams();
  const activeTabIndex = tabs.includes(searchParams.get('tab') || '')
    ? tabs.indexOf(searchParams.get('tab') || '')
    : 0;
  const [tabIndex, setTabIndex] = React.useState(activeTabIndex);
  const handleTabsChange = (index: number) => setTabIndex(index);

  useEffect(() => {
    setTabIndex(activeTabIndex);
  }, [searchParams]);

  const tabStyle: React.CSSProperties = React.useMemo(
    () => ({
      borderBottomColor: theme.colors.blue,
      color: theme.colors.blue,
    }),
    [theme]
  );

  return (
    <Tabs index={tabIndex} onChange={handleTabsChange} align="center">
      <TabList>
        {tabs.map((tab) => (
          <Tab key={tab} _selected={tabStyle}>
            {tab}
          </Tab>
        ))}
      </TabList>

      <TabPanels p={0}>
        <TabPanel textAlign={'left'} p={0} pt={3}>
          <EventAbout event={event} eventOffers={eventOffers || []} refetchEvent={refetchEvent} />
        </TabPanel>

        {relatedEvents.length > 0 && (
          <TabPanel pt={3} pb="50px">
            <RelatedEvents events={relatedEvents} />
          </TabPanel>
        )}
      </TabPanels>
    </Tabs>
  );
};

export default EventTabs;